/**
 * Modèle PlayerPath - Identique à Flutter
 */

import {PlayerCondition, PlayerConditionFromJson} from './PlayerCondition';

export interface PlayerPath {
  title: string;
  description: string;
  child: number; // Numéro de l'étape cible
  conditions: PlayerCondition[];
  [key: string]: any;
}

export const PlayerPathFromJson = (json: any): PlayerPath => {
  if (!json || typeof json.description !== 'string') {
    throw new Error('Invalid PlayerPath JSON: missing description');
  }

  return {
    title: json.description, // Utilise description comme title (comme Flutter)
    description: json.description,
    child: Number(json.child) || 0,
    conditions: (json.conditions as any[] || []).map((c) => PlayerConditionFromJson(c)),
    ...json, // Conserver tous les autres champs
  };
};
